import * as THREE from "three";
import { useRef } from "react";

export default function useARElements(scene) {
  const cubeRef = useRef(null);
  const planeRef = useRef(null);

  if (!cubeRef.current) {
    const geometry = new THREE.BoxGeometry(0.1, 0.1, 0.1);
    const material = new THREE.MeshStandardMaterial({ color: 0xff0000 });
    const cube = new THREE.Mesh(geometry, material);
    cube.visible = false;
    scene.add(cube);
    cubeRef.current = cube;
  }

  if (!planeRef.current) {
    const geometry = new THREE.PlaneGeometry(1, 1, 10, 10);
    const material = new THREE.PointsMaterial({ color: 0xffffff, size: 0.02 });
    const plane = new THREE.Points(geometry, material);
    plane.rotation.x = -Math.PI / 2;
    plane.visible = false;
    scene.add(plane);
    planeRef.current = plane;
  }

  return { cube: cubeRef.current, planeMesh: planeRef.current };
}
